<app-viewer [ref]="page" (click)="next()"></app-viewer>
<div class="playlist-controls">
  <button type="button" (click)="back()">◀️</button>
  <button type="button" (click)="next()">▶️</button>
</div>
